<template>
  <b-modal size="lg" scrollable v-model="show" centered :title="title" @hidden="hidden">
  <b-row>
    <b-col>
      <b-form-input v-model="searchVal" placeholder="Suche" type="search" debounce="150"></b-form-input>
      <b-table hover responsive  id="my-table"
               style="height: 450px"
               :items="tableData"
               :tbody-tr-class="rowClass"
               :fields="fields"
               @row-clicked="onRowSelected">
        <template v-slot:cell(shared)="row">
          <chat-icon v-if="wasForwarded(row.item.id)" class="icon-2x" :size="72" style="cursor: pointer; color: #3EA662" @click.prevent="onOpen(row.item.id)"></chat-icon>
        </template>
      </b-table>
      <b-row class="mt-3" v-if="selected.length > 1 && !isShare && !isNormalShare">
        <b-col>
          <span>Chatname:</span>
          <b-form-input style="margin-top: 0.75rem" class="form-control text-black"
                        v-model="chatName"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="isShare">
        <b-col>
          <span>Nachricht:</span>
        <b-form-textarea class="text-black"
                         style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                         rows="3"
                         no-resize
                         v-model="message"
                         wrap="hard"
        ></b-form-textarea>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="cancel">
        Abbrechen
      </b-button>
      <b-button size="md"  variant="success" :disabled="!canContinue" @click="onFinish">
        {{okButton}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>

import ChatIcon from 'vue-material-design-icons/ChatOutline.vue';
export default {
  name: "StructureList",
  components: {ChatIcon},
  props:{
    multiSelect: {
      type: Boolean,
      default: () => false
    },
    bauhofStructure: {
      type: Array,
      default: () => []
    },
    sharedUsers: {
      type: Array,
      default: () => []
    },
    isShare: {
      type: Boolean,
      default: () => false
    },
    isNormalShare: {
      type: Boolean,
      default: () => false
    },
  },
  computed: {
    fields() {
      if (this.multiSelect) {
        if (this.isShare) {
          return [
            {key: 'name', label: 'Name'},
            {key: 'parent', label: 'Abteilung'},
          ]
        } else {
          return [
            {key: 'name', label: 'Name'},
            {key: 'parent', label: 'Abteilung'},
          ]
        }
      } else {
        return [
          {key: 'name', label: 'Name'},
        ]
      }
    },
    selected() {
      let res = [];
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].selected) {
          res.push(this.items[i])
        }
      }
      return res;
    },
    canContinue() {
      if (this.selected.length === 1) {
        return true;
      } else if (this.isNormalShare && this.selected.length > 1) {
        return true;
      } else if (this.multiSelect && !this.isShare && this.selected.length > 1 && this.chatName !== '') {
        return true;
      } else if (this.isShare && this.selected.length > 1) {
        return true
      }
      return false
    },
    title() {
      if (this.isShare || this.isNormalShare) {
        return "An wen soll weitergeleitet werden ?"
      } else if (this.multiSelect) {
        return "Teilnehmer auswählen"
      } else {
        return "Nutzer hinzufügen"
      }
    },
    okButton() {
      if (this.isShare || this.isNormalShare) {
        return "Weiterleiten"
      } else if (this.multiSelect) {
        return "Chat starten"
      } else {
        return "Hinzufügen"
      }
    },
    tableData: function() {
      if (this.searchVal === '') {
        return this.items;
      } else {
        return this.items.filter((data) => data.name.toLowerCase().includes(this.searchVal.toLowerCase()) || data.parent.toLowerCase().includes(this.searchVal.toLowerCase()))
      }
    },
    selectMode() {
      return this.multiSelect ? 'multi' : 'single'
    }
  },
  data: () => {
    return {
      items: [],
      searchVal: '',
      selection: [],
      chatName: '',
      show: false,
      message: "",
    }
  },
  methods: {
    hidden() {
      this.$emit("hidden")
    },
    wasForwarded(userId) {
      for (let i = 0; i < this.sharedUsers.length; i++) {
        if (this.sharedUsers[i] === userId) {
          return true;
        }
      }
      return false;
    },
    onFinish() {
      this.$emit("on-selected", this.getReturnData());
      this.show = false;
    },
    onOpen(userId) {
      this.$emit("on-forward-open", userId);
      this.show = false;
    },
    showModal() {
      this.$nextTick(() => {
      let n = this.bauhofStructure;
      if (!n || !n.length) {
        return;
      }
      let input = JSON.parse(JSON.stringify(n));
      this.computeMitas(input)
      let res = this.computeStructure(input, "Kommune");
      res.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      this.items = res;
      this.chatName = '';
      this.message = "";
      this.show = true;
      })
    },
    getReturnData() {
      let selectedIds = [];
      let selectedNames = [];
      for (let i = 0; i < this.selected.length; i++) {
        selectedIds.push(this.selected[i].id);
        selectedNames.push(this.selected[i].name);
      }
      return {
        ids: selectedIds,
        names: selectedNames,
        room_name: this.chatName,
        message: this.message,
      }
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.selected === true) return 'table-primary table-cursor'
      return 'table-cursor'
    },
    onRowSelected(item, index, event) {
      if (item.selected) {
        item.selected = false
      } else {
        if (this.multiSelect) {
          item.selected = true
        } else {
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].selected) {
              this.items[i].selected = false;
            }
          }
          item.selected = true
        }
      }
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
    computeStructure(data, nodeName) {
      if (!data) {
        return []
      }
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {
            id: data[i].id,
            name: data[i].text,
            node_type: data[i].node_type,
            parent: nodeName,
            selected: false,
          }
          res.push(cur)
        } else {
          res.push(...this.computeStructure(data[i].children, data[i].text))
        }
      }
      return res;
    }
  },
  }
</script>

<style>
.table-cursor {
  cursor: pointer;
}
</style>
